
import Loading from "common/fragments/Loading";
import { IPanelProps, Panel } from "core/decorators/Panel";
import React from "react";
import Query from "core/api/QueryComponent";
import labelProvider from '../../panels/learningSummary/LearningSummary.labels';
import { CreditSummaryView } from "./CreditSummaryView";
import DropdownSelect from "common/form/widgets/common/DropdownSelect";
import { SeparatorView } from "common/views/separator/Separator.view";
import Label from "core/components/label/Label";
import { BlockView } from "common/views/block/BlockView.view";
import CreditSummaryConfig from "./CreditSummaryConfig";
import {CreditEntriesUser, CreditUserCount} from "./CreditSummary";
import { NonIdealState } from "@blueprintjs/core";

const { Labels } = labelProvider;

function mapCreditEntryParams(pageCount, globalParams: any = {}) {
	const params = {
		granted: true,
		pageSize: pageCount,
	}
	if (globalParams.creditTypeIds) {
		params["creditTypeIds"] = globalParams.creditTypeIds;
	}
	
	return {params};
}

let yearOptions = [{label:'All', value: 'All'}];

/**
 * CreditSummaryPanel displays granted credits summary
 *
 */
@Panel({ id: "Credits-summary", configClass: CreditSummaryConfig, pageParams: true, labelProvider })
export class CreditSummaryPanel extends React.Component<IPanelProps<CreditSummaryConfig>> {

	private getSummaryData = (data) => {
		let result = [...data];
		let summaryData = [];
		const { pageParams } = this.props;
		const { completedYear } = pageParams;
		let year = new Date().getFullYear().toString();
		if (completedYear) {
			year = completedYear;
		}

		// adding year options available in query response
		yearOptions = result.reduce((years, currentItem) => {
			const completedYear = new Date(currentItem.completedOn).getFullYear().toString();
			if(!years.some((i) => i.value === completedYear)){
				years.push({label:completedYear, value: completedYear});
			}
			return years;
		},yearOptions);

		// adding year option present in completed table filter option but not in credit summary
		const newItem = year && !yearOptions.some(item => item.label === year);
		if (newItem) {
			const index = yearOptions.findIndex(item => (item.label !== 'All' && parseInt(item.label) > parseInt(year)));
			yearOptions.splice(index === -1 ? yearOptions.length : index, 0, {label: year, value: year});
		}


		if(year !== 'All'){
			result = data.filter(credit=>credit.completedOn.includes(year));
		}

		let summary = result.reduce((acc,credit) => {
			if(acc[credit.type.name]){
				acc[credit.type.name]+=credit.value
			} else{
				acc[credit.type.name]=credit.value
			}
			acc['Total'] += credit.value;
			return acc;
		},{Total: 0});

		Object.keys(summary).reverse().forEach((property: string) => summaryData.push({id: property, title: property, value: summary[property]}));
		return summaryData;
	}

	private onChangeField = (val) => {
		this.props.actions.pushPageParams({key: 'completedYear', value: val});
	}

	public render() {

		const {config, pageParams } = this.props;
		const { completedYear } = pageParams;
		let year = new Date().getFullYear().toString();
		if (completedYear) {
			year = completedYear;
		}

		return (
			<Query.One entity={CreditUserCount} args={{granted: true}}>
				{({ data,loading }) => {
					if (loading) {
						return <Loading key="loading" />;
					}
					if (!data || !data.count) {
						return  (<NonIdealState
							title={""}
							description={"There is no credit data to show."}
						/>)
					}
					const pageCount = data.count;
					const params = {...mapCreditEntryParams(pageCount)};
					const res = {...params.params}
					return (
						<Query.Many entity={CreditEntriesUser} args={res}>
							{({ data,loading }) => {
								if (loading) {
									return <Loading key="loading" />;
								}

								if (!Array.isArray(data) || data.length === 0) {
									return (<NonIdealState
										title={""}
										description={"There is no credit data to show."}
									/>)
								}
				
								return (
									<React.Fragment>
											<SeparatorView viewKey="select-separator" />
											{ config.enableYearFilter ? (
											<BlockView viewKey="dropdown">
												<div style={{display: 'flex'}}>
													<Label k="credit.filter.message" v="Credits earned:" />
													<DropdownSelect
														buttonProps={{
															minimal: true,
															small: true,
														}}
														options={yearOptions}
														value={year}
														onChange={(val)=>this.onChangeField(val)}
													/>
												</div>
											</BlockView>
											) : ''}
											<CreditSummaryView
												blockData={this.getSummaryData(data)}
												viewKey={"credit.earned"}
											/>
										</React.Fragment>
								);
							}}
						</Query.Many>
					)
				}}
			</Query.One>
		)
	}
}



// WEBPACK FOOTER //
// ./src/panels/creditSummary/CreditSummary.panel.tsx